<div fxLayout="column">
    <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>Tipo</mat-label>
        <mat-select
            [(ngModel)]="tipo"
            class="roleSelect"
            (selectionChange)="doUpdate()"
            [disabled]="action == 'View'"
            [compareWith]="compareObjects"
            required="true"
        >
            <mat-option *ngFor="let tipo of tipos" [value]="tipo.value">
                {{ tipo.nombre }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div fxLayout="column">
    <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <mat-label>Sector de actividad</mat-label>
        <mat-select
            [(ngModel)]="GENERAL_DATA.sectorIndustrial"
            class="roleSelect"
            required="true"
            [disabled]="action == 'View'"
            [compareWith]="compareObjects"
            (selectionChange)="doUpdate()"
        >
            <mat-option
                *ngFor="let tipo of tiposSectorIndustrial"
                [value]="tipo"
            >
                {{ tipo.nombre }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div
    fxLayout="column"
    id="personaFisica"
    *ngIf="tipo == 'PERSONA_FISICA' && action != 'Delete'"
>
    <div fxLayout="column">
        <mat-form-field *ngIf="action != 'Delete'" class="select-list">
            <mat-label>Profesión</mat-label>
            <mat-select
                [(ngModel)]="GENERAL_DATA.profesion"
                class="roleSelect"
                [disabled]="action == 'View'"
                [compareWith]="compareObjects"
                (selectionChange)="doUpdate()"
            >
                <mat-option
                    *ngFor="let profesion of tiposProfesiones"
                    [value]="profesion"
                >
                    {{ profesion.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="column">
        <mat-checkbox
            class="example-margin"
            [(ngModel)]="GENERAL_DATA.personaPoliticamenteExpuesta"
            (change)="saveValue(sentencia, element)"
            (ngModelChange)="doUpdate()"
            >Persona politícamente expuesta</mat-checkbox
        >
    </div>

    <div fxLayout="row">
        <mat-form-field
            *ngIf="action != 'Delete' && action != 'Reset'"
            class="select-medio"
            fxFlex="100"
        >
            <input
                placeholder="Nombre"
                matInput
                [(ngModel)]="GENERAL_DATA.nombre"
                required="true"
                (ngModelChange)="doUpdate()"
            />
        </mat-form-field>
        <mat-form-field
            *ngIf="action != 'Delete' && action != 'Reset'"
            class="select-medio"
            fxFlex="100"
        >
            <input
                placeholder="Segundo nombre"
                matInput
                [(ngModel)]="GENERAL_DATA.segundoNombre"
                (ngModelChange)="doUpdate()"
            />
        </mat-form-field>
    </div>

    <div fxLayout="row">
        <mat-form-field
            *ngIf="action != 'Delete' && action != 'Reset'"
            class="select-medio"
            fxFlex="100"
        >
            <input
                placeholder="Apellido"
                matInput
                required="true"
                [(ngModel)]="GENERAL_DATA.apellido"
                (ngModelChange)="doUpdate()"
            />
        </mat-form-field>
        <mat-form-field
            *ngIf="action != 'Delete' && action != 'Reset'"
            class="select-medio"
            fxFlex="100"
        >
            <input
                placeholder="Segundo apellido"
                matInput
                [(ngModel)]="GENERAL_DATA.segundoApellido"
                (ngModelChange)="doUpdate()"
            />
        </mat-form-field>
    </div>

    <div fxLayout="row">
        <mat-form-field
            *ngIf="action != 'Delete'"
            class="select-list"
            fxFlex="100"
        >
            <mat-label>País de nacimiento</mat-label>
            <mat-select
                [(ngModel)]="GENERAL_DATA.lugarNacimiento"
                class="roleSelect"
                [disabled]="action == 'View'"
                [compareWith]="compareObjects"
                (selectionChange)="doUpdate()"
            >
                <mat-option *ngFor="let pais of paises" [value]="pais">
                    {{ pais.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxFlex="100">
        <mat-form-field color="accent" appearance="fill">
            <mat-label>Fecha de nacimiento</mat-label>
            <input
                matInput
                [matDatepicker]="picker1"
                [(ngModel)]="GENERAL_DATA.fechaNacimiento"
                (dateChange)="doUpdate()"
            />
            <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
    </div>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Datos de contacto</legend>
        <div fxLayout="column">
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-full"
                fxFlex="100"
            >
                <input
                    placeholder="Correo electrónico"
                    matInput
                    [(ngModel)]="GENERAL_DATA.correoElectronico"
                    (ngModelChange)="doUpdate()"
                />
            </mat-form-field>

            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    class="select-full"
                    fxFlex="100"
                >
                    <input
                        placeholder="Teléfono"
                        matInput
                        [(ngModel)]="GENERAL_DATA.telefono.numero"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    class="select-full"
                    fxFlex="100"
                >
                    <input
                        placeholder="Interno"
                        matInput
                        [(ngModel)]="GENERAL_DATA.telefono.interno"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Documento de identificación</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País emisor</mat-label>
                    <mat-select
                        [(ngModel)]="razonSocialPais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (ngModelChange)="loadDocumentsTypes()"
                        (selectionChange)="doUpdate()"
                    >
                        <ng-container *ngFor="let pais of paises">
                            <mat-option [value]="pais">
                                {{ pais.nombre }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>Tipo de documento</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.documentoIdentidad.tipo"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <ng-container *ngFor="let tipo of tiposDocumentos">
                            <mat-option [value]="tipo">
                                {{ tipo.nombre }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de documento"
                        matInput
                        [(ngModel)]="GENERAL_DATA.documentoIdentidad.numero"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <div fxFlex="100">
                    <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de emisión</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker1"
                            [(ngModel)]="
                                GENERAL_DATA.documentoIdentidad.fechaExpedicion
                            "
                            (dateChange)="doUpdate()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker1"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>

                <div fxFlex="100">
                    <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de expiración</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker2"
                            [(ngModel)]="
                                GENERAL_DATA.documentoIdentidad.fechaVencimiento
                            "
                            (dateChange)="doUpdate()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker2"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Domicilio</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.direccionFisica.pais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <mat-option *ngFor="let pais of paises" [value]="pais">
                            {{ pais.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Localidad"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFisica.localidad"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>

            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Calle"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFisica.calle"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de puerta"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFisica.numeroDePuerta
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Unidad"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFisica.numeroDeApartamento
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="tipo == 'PERSONA_JURIDICA' && action != 'Delete'">
        <legend>Dirección</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.pais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <mat-option *ngFor="let pais of paises" [value]="pais">
                            {{ pais.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Localidad"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.localidad"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Calle"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.calle"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de puerta"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFiscal.numeroDePuerta
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Unidad"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFiscal.numeroDeApartamento
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
        </div>
    </fieldset>
</div>

<div
    fxLayout="column"
    id="personaJuridica"
    *ngIf="tipo == 'PERSONA_JURIDICA' && action != 'Delete'"
>
    <div fxLayout="row">
        <mat-form-field
            *ngIf="action != 'Delete' && action != 'Reset'"
            class="select-medio"
            fxFlex="100"
        >
            <input
                placeholder="Nombre"
                matInput
                [(ngModel)]="GENERAL_DATA.nombre"
                (ngModelChange)="doUpdate()"
            />
        </mat-form-field>
    </div>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Datos de contacto</legend>
        <div fxLayout="column">
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-full"
                fxFlex="100"
            >
                <input
                    placeholder="Correo electrónico"
                    matInput
                    [(ngModel)]="GENERAL_DATA.correoElectronico"
                    (ngModelChange)="doUpdate()"
                />
            </mat-form-field>

            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    class="select-full"
                    fxFlex="100"
                >
                    <input
                        placeholder="Teléfono"
                        matInput
                        [(ngModel)]="GENERAL_DATA.telefono.numero"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    class="select-full"
                    fxFlex="100"
                >
                    <input
                        placeholder="Interno"
                        matInput
                        [(ngModel)]="GENERAL_DATA.telefono.interno"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Documento de identificación</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País emisor</mat-label>
                    <mat-select
                        [(ngModel)]="razonSocialPais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (ngModelChange)="loadDocumentsTypes()"
                    >
                        <ng-container *ngFor="let pais of paises">
                            <mat-option [value]="pais">
                                {{ pais.nombre }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>Tipo de documento</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.razonSocial.tipo"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <ng-container *ngFor="let tipo of tiposDocumentos">
                            <mat-option [value]="tipo">
                                {{ tipo.nombre }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de documento"
                        matInput
                        [(ngModel)]="GENERAL_DATA.razonSocial.numero"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <div fxFlex="100">
                    <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de emisión</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker1"
                            [(ngModel)]="
                                GENERAL_DATA.razonSocial.fechaExpedicion
                            "
                            (dateChange)="doUpdate()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker1"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                </div>

                <div fxFlex="100">
                    <mat-form-field color="accent" appearance="fill">
                        <mat-label>Fecha de expiración</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker2"
                            [(ngModel)]="
                                GENERAL_DATA.razonSocial.fechaVencimiento
                            "
                            (dateChange)="doUpdate()"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker2"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Dirección</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Calle"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFisica.calle"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de puerta"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFisica.numeroDePuerta
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Unidad"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFisica.numeroDeApartamento
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Localidad"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFisica.localidad"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.direccionFisica.pais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <mat-option *ngFor="let pais of paises" [value]="pais">
                            {{ pais.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset *ngIf="action != 'Delete'">
        <legend>Dirección Fiscal</legend>
        <div fxLayout="column">
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Calle"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.calle"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Número de puerta"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFiscal.numeroDePuerta
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Unidad"
                        matInput
                        [(ngModel)]="
                            GENERAL_DATA.direccionFiscal.numeroDeApartamento
                        "
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <mat-form-field
                    *ngIf="action != 'Delete' && action != 'Reset'"
                    fxFlex="100"
                >
                    <input
                        placeholder="Localidad"
                        matInput
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.localidad"
                        (ngModelChange)="doUpdate()"
                    />
                </mat-form-field>

                <mat-form-field
                    *ngIf="action != 'Delete'"
                    class="select-list"
                    fxFlex="100"
                >
                    <mat-label>País</mat-label>
                    <mat-select
                        [(ngModel)]="GENERAL_DATA.direccionFiscal.pais"
                        class="roleSelect"
                        [disabled]="action == 'View'"
                        [compareWith]="compareObjects"
                        (selectionChange)="doUpdate()"
                    >
                        <mat-option *ngFor="let pais of paises" [value]="pais">
                            {{ pais.nombre }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </fieldset>
</div>
